import { useEffect } from "react";
import { UseAuthentication } from "../../services/authentication/authentication.context";

export const AuthPage = () => {
    const { isAuthenticated } = UseAuthentication();

    useEffect(() => {
        if (isAuthenticated) {
            isAuthenticated === false ?
                window.location.href = "/signin" :
                window.location.href = "/admin";
        }
        return;
    }, [isAuthenticated])
}